import React from 'react'
import gql from 'graphql-tag';
import MutationManager from './Mutation';

const CANCEL_ORDER = gql`
  mutation cancelOrder($input: CancelOrderInput) {
    cancelOrderById(input: $input) {
      id,
      status,
      customer {
        firstName,
        lastName
      }
    }
  }
`

const CancelOrder = ({ children, ...props }) => (
  <MutationManager mutation={CANCEL_ORDER} refetchQueries={['getOrderById', 'getOrderItems', 'getPickingInfoBy']}>
    {
      ({ data, loading, updateFn }) => children({ data, loading, updateFn })
    }
  </MutationManager>
)

export {
  CANCEL_ORDER
}

export default CancelOrder
